module.exports = "/dist/assets/images/thumbs-up-filled-icn.png";